'use client';

import { css } from 'styled-components';

export type Fonts = { primary: string; secondary: string };

export const fontTokens: Fonts = {
  primary: '--font-primary',
  secondary: '--font-secondary',
};

export const generateFontTokens = (values: Record<keyof typeof fontTokens, string>) => {
  return css`
    ${fontTokens.primary}: ${values.primary};
    ${fontTokens.secondary}: ${values.secondary};
  `;
};
